// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2023 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//
import { cartTitleStyles } from "@guestsupply/App/Widgets/Cart/CartTitle";
import TypographyStyle from "@insite/mobius/Typography/TypographyStyle";
import { css } from "styled-components";

cartTitleStyles.container = {
    css: css`
        display: flex;
        align-items: baseline;
        gap: 32px;
    `,
};
cartTitleStyles.pageTitle = {
    variant: "h1",
    css: css`
        margin-bottom: 0;
        /* Override OOTB h1 print style */
        @media print {
            font-size: 32px !important;
        }
    `,
};
cartTitleStyles.itemCountText = {
    size: 20,
    weight: "bold",
};
